"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueTemplatesField = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _alloyReactModal = _interopRequireWildcard(require("@adsk/alloy-react-modal"));
var _FieldWrapper = require("../input-field-components/FieldWrapper");
var _useLocalStorage = require("../hooks/useLocalStorage");
var _hooks = require("../state/redux/hooks");
var _useTranslations = require("../utils/i18n/useTranslations");
var _IssueTemplatesDropdown = require("../input-field-components/IssueTemplatesDropdown");
var _issueTemplates = require("../state/redux/ducks/issueTemplates");
var _getIssueAttributesFromTemplate = require("../utils/data/getIssueAttributesFromTemplate");
var _useIncrementor = require("../utils/hooks/useIncrementor");
var _useGetTemplateTransformedForCurrentUser = require("../utils/hooks/useGetTemplateTransformedForCurrentUser");
var _useLocalizedDecimalSeparator = require("../hooks/useLocalizedDecimalSeparator");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const IssueTemplatesField = _ref => {
  let {
    onTemplateChanged
  } = _ref;
  const {
    values,
    setFieldValue,
    setFieldTouched,
    resetForm,
    dirty
  } = (0, _formik.useFormikContext)();
  const getTemplateById = (0, _hooks.useSelector)(_issueTemplates.getFnForGetIssueTemplateById);
  const {
    localizeNumericCustomFields
  } = (0, _useLocalizedDecimalSeparator.useLocalizedDecimalSeparator)();
  const [, setLastSelectedTypeId] = (0, _useLocalStorage.useLocalStorage)(_useLocalStorage.LocalStorageKeys.LAST_SELECTED_TYPE_ID);
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const [pendingTemplateId, setPendingTemplateId] = (0, _react.useState)(undefined);
  const [key, incrementKey] = (0, _useIncrementor.useIncrementor)();
  const getTemplateTransformedForCurrentUser = (0, _useGetTemplateTransformedForCurrentUser.useGetTemplateTransformedForCurrentUser)();
  const handleTemplateChange = (0, _react.useCallback)(templateId => {
    const fieldName = "templateId";
    setFieldValue(fieldName, templateId || "");
    setFieldTouched(fieldName, true, false);
    if (!templateId) {
      // templateId is undefined when the `clear` button is clicked.
      // in that case, we just want to empty the template field, but not change
      // any of the other fields
      onTemplateChanged && onTemplateChanged();
      return;
    }
    const templateFromState = getTemplateById(templateId);
    if (templateFromState) {
      const template = getTemplateTransformedForCurrentUser({
        template: templateFromState
      });
      const issueFormAttributesFromTpl = (0, _getIssueAttributesFromTemplate.getIssueFormAttributesFromTemplate)(template);
      localizeNumericCustomFields(issueFormAttributesFromTpl.customAttributes);
      issueFormAttributesFromTpl.templateId = templateId;
      setLastSelectedTypeId(template.issueAttributes.typeId);
      resetForm({
        values: issueFormAttributesFromTpl
      });
      onTemplateChanged && onTemplateChanged();
    } else {
      console.error("Template data could not be loaded: this should not occur", templateId);
    }
  }, [setFieldValue, setFieldTouched, getTemplateById, onTemplateChanged, getTemplateTransformedForCurrentUser, localizeNumericCustomFields, setLastSelectedTypeId, resetForm]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FieldWrapper.FieldWrapper, {
    key: key,
    label: T.translate("issueCreation.template.fieldTitle")
  }, /*#__PURE__*/_react.default.createElement(_IssueTemplatesDropdown.IssueTemplatesDropdown, {
    selectedIssueTemplateId: values.templateId,
    onChange: templateId => {
      if (!dirty || !templateId) {
        handleTemplateChange(templateId);
      } else {
        setPendingTemplateId(templateId);
      }
    }
  })), /*#__PURE__*/_react.default.createElement(_alloyReactModal.ModalConfirmation, {
    style: {},
    show: !!pendingTemplateId,
    size: _alloyReactModal.default.SIZES.MEDIUM,
    onConfirm: () => {
      if (pendingTemplateId) {
        handleTemplateChange(pendingTemplateId);
      }
      setPendingTemplateId(undefined);
      incrementKey();
    },
    onClose: () => {
      setPendingTemplateId(undefined);
      // if we don't trigger a reinstantiation here, the component will render without
      // the placeholder in certain situations (namely: if the form was edited, then the template cleared,
      // then a new template selected, triggering this modal, then cancelled/closed)
      // .. this is all due to the internal state of the alloy component.
      // And reinstantiation is the way to fix weird internal states of components...
      incrementKey();
    },
    title: T.translate("issueCreation.template.confirmationModalTitle"),
    message: T.translate("issueCreation.template.confirmationModalDescription"),
    confirmationButtonLabel: T.translate("issueCreation.template.confirmationModalButton")
  }));
};
exports.IssueTemplatesField = IssueTemplatesField;
//# sourceMappingURL=IssueTemplatesField.js.map